import { useAppDispatch, useAppSelector } from 'app/hooks'
import { SocketClient } from 'app/socketIO'
import { useEffect } from 'react'

export default function SocketIO() {
  const dispatch = useAppDispatch()
  const rootState = useAppSelector((s) => s)
  useEffect(() => {
    const socket = new SocketClient(dispatch, rootState)
    if (rootState.UI.auth) {
      socket.connect()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rootState.UI.auth])
  return null
}
